import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/assets/styles/common.scss";
import '@/assets/font/font.css';
import '@/assets/styles/reset.css';
import pagination from "@/components/pagination/pagination.vue";

//element-ui
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

import {
  post,
  get,
  Delete,
  put,
  // cardPost,
  // cardGet,
  // cardPut,
  // cardDelete,
} from "@/api/http.js";
import url from "@/api/url.js"
import '@/router/permission' // 路由守卫
import { mapState } from 'vuex';
import course_list from "@/common/course_list"
import md5 from 'js-md5';
import utils from "@/utils/utils"
import bitMap from '@/directives/bitmap';
import hasPermi from '@/directives/hasPermi'; // 导入自定义指令
import { downloadFile } from '@/common/downloadFile.js'; // 替换为正确的路径
import YearRangePicker from '@/components/year-range-picker/yearRangePicker.vue'; // 引入组件

Vue.config.productionTip = false


Vue.prototype.post = post;
Vue.prototype.get = get;
Vue.prototype.delete = Delete;
Vue.prototype.put = put;
// Vue.prototype.cardPost = cardPost;
// Vue.prototype.cardGet = cardGet;
// Vue.prototype.cardDelete = cardDelete;
// Vue.prototype.cardPut = cardPut;
Vue.prototype.$url = url;
Vue.prototype.$courseList = course_list;
Vue.prototype.$md5 = md5;
Vue.prototype.$utils = utils;
Vue.prototype.$downloadFile = downloadFile;
Vue.prototype.$eventBus = new Vue();

// 全局注册自定义组件
Vue.component('pagination', pagination);
Vue.component('YearRangePicker', YearRangePicker);

Vue.directive('bitmap', bitMap)
Vue.directive('hasPermi', hasPermi);

Vue.mixin({
  computed: {
    ...mapState(Object.keys(store.state))
  }
})

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vue